import React from 'react';
import IndustryPageTemplate from '../../components/IndustryPageTemplate';
import SEO from '../../components/SEO';

const SwimmingLessons = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How can Local Business Heroes help my swimming lessons business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Local Business Heroes helps swimming lessons businesses capture more leads, automate follow-ups, reduce no-shows, and grow faster. Rated 4.9/5 by 1,200+ UK businesses."
        }
      },
      {
        "@type": "Question",
        "name": "How much does it cost for swimming lessons businesses?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Plans start at £297/month with a 14-day trial for just £5. Most swimming lessons businesses see ROI within the first month."
        }
      },
      {
        "@type": "Question",
        "name": "Do I need technical skills to use it?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No. Local Business Heroes is designed for busy business owners with zero tech experience. Setup takes 5 minutes with UK-based support."
        }
      },
      {
        "@type": "Question",
        "name": "Will it work for my swimming lessons business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. Local Business Heroes is specifically designed for local service businesses like swimming lessons. Features include appointment scheduling, automated reminders, lead capture, and customer management."
        }
      }
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "CRM for Swimming Lessons - Local Business Heroes",
    "applicationCategory": "BusinessApplication",
    "offers": {
      "@type": "Offer",
      "price": "297",
      "priceCurrency": "GBP"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "1200"
    }
  };

  const breadcrumbs = [
    { name: "Home", url: "/" },
    { name: "Industries", url: "/industries" },
    { name: "Swimming Lessons CRM", url: "/industries/swimming-lessons" }
  ];

  const industryData = {
    name: 'Swim School',
    title: 'Fill Classes & Progress Students Through All Levels',
    subtitle: 'Automate enrollment, track skill progression, and keep classes full year-round',
    icon: '🏊',
    challenges: [
      'Summer classes fill but fall enrollment drops',
      'Students quit mid-level progression',
      'Hard to manage makeup lessons',
      'Waitlist management is chaotic',
      'Private lesson scheduling conflicts'
    ],
    solutions: [
      'Year-round enrollment automation',
      'Level progression tracking',
      'Makeup lesson automation',
      'Waitlist management system',
      'Private lesson booking'
    ],
    features: [
      'Student CRM with level tracking',
      'Class enrollment automation',
      'Skill progression reports',
      'Makeup lesson scheduling',
      'Waitlist automation',
      'Private lesson booking',
      'Payment automation',
      'Review requests'
    ],
    results: [
      '85% year-round enrollment',
      '80% complete level progression',
      'Fill 100% of summer slots',
      '5.5K average monthly revenue increase'
    ]
  };

  return (
    <>
      <SEO 
        title="CRM for Swimming Lessons UK | Marketing Automation | Local Business Heroes"
        description="Rated 4.9/5. CRM and marketing automation for swimming lessons businesses. Capture more leads, automate follow-up, grow faster. Start £5 trial today."
        keywords="CRM for swimming lessons UK, swimming lessons business software, swimming lessons customer management, swimming lessons lead generation UK"
        url="/industries/swimming-lessons"
        schemaMarkup={[faqSchema, localBusinessSchema]}
        breadcrumbs={breadcrumbs}
      />
      <IndustryPageTemplate industry={industryData} />
    </>
  );
};

export default SwimmingLessons;